import React, { useState, useEffect, useCallback, useRef } from 'react';
import * as d3 from 'd3';
import { useNavigate } from 'react-router-dom';
import useApi from '../../api/useApi';

function index({ openDeviceInfo, notification, handleClose }) {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const { userId } = JSON.parse(sessionStorage.user).user;
  const history = useNavigate();
  const uploadFile = useRef(null);
  const [devices, setDevices] = useState([]);
  const [incorrectData, setIncorrectData] = useState([]);
  const [showLoader, setLoader] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [save, setSave] = useState(false);
  const [fileName, setFileName] = useState('');
  const [state, getOrganizations] = useApi();
  const [{ isLoading, isError, data }, saveUploadFile] = useApi();
  const missingData = [];
  useEffect(() => {
    getOrganizations('/organizations', 'GET');
  }, []);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setOrganizations(state.data.organization);
    }
    if (state.isError) {
      notification('error', 'Unable to fetch Organizations');
    }
  }, [state]);
  const handleFiles = () => {
    (async () => {
      const text = await uploadFile.current.files[0].text();
      const uploadCsvFile = await d3.csvParse(text);
      if (
        uploadCsvFile[0].DEVICE_ID !== undefined &&
        uploadCsvFile[0].DEVICE_TYPE !== undefined &&
        uploadCsvFile[0].ATTRIBUTES !== undefined &&
        uploadCsvFile[0].ORGANIZATION !== undefined &&
        uploadCsvFile[0].DEVICE_MANAGER !== undefined &&
        uploadCsvFile[0].MANUFACTURER !== undefined
      ) {
        setFileName(uploadFile.current.files[0].name);
        setDevices(uploadCsvFile);
        setSave(!save);
      } else {
        notification('error', 'PLEASE CHECK ATTRIBUTES NAME');
      }
    })();
  };

  const onClick = () => {
    uploadFile.current.click();
  };
  const getId = (name, i) => {
    const org = organizations.filter((item) => item.organizationName === name);
    if (org[0]?.id === undefined) {
      missingData.push({ device: devices[i], row: i });
      return null;
    }
    return org[0].id;
  };
  const uploadDevice = async () => {
    setLoader(true);
    const body = await Promise.all(
      devices.map((device, i) => {
        if (
          device.DEVICE_TYPE === 'BLE_GW' ||
          device.DEVICE_TYPE === 'BLE_TAG' ||
          device.DEVICE_TYPE === 'CATM1_TAG' ||
          device.DEVICE_TYPE === 'PHONE_GW' ||
          device.DEVICE_TYPE === 'NFC_TAG'
        ) {
          return new Promise((resolve, reject) => {
            const _device = {
              DEVICE_ID: device.DEVICE_ID,
              DEVICE_TYPE: device.DEVICE_TYPE,
              ATTRIBUTES: device.ATTRIBUTES,
              ORGANIZATION: getId(device.ORGANIZATION, i),
              DEVICE_MANAGER: getId(device.DEVICE_MANAGER, i),
              MANUFACTURER: getId(device.MANUFACTURER, i),
              CREATEDBY: userId,
            };

            resolve(_device);
          });
        }
        missingData.push({ device, row: i + 1 });
      }),
    );
    if (missingData.length === 0) {
      saveUploadFile('/devices', 'POST', body);
    } else {
      setIncorrectData(missingData);
      notification('error', 'Some DeviceInfo is Incorrect');
    }
  };
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setSave(!save);
      setFileName('');
      setDevices([]);
      setLoader(false);
      notification('success', 'CSV Uploaded Successfully');
      history('/inventory', { replace: true }); // fixed navigation
    }
    if (isError) {
      setLoader(false);
      notification('error', 'Unable to upload csv.');
    }
  }, [isLoading, isError, data]);

  return (
    <div
      className="flex justify-center items-center h-full w-full z-50 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className="bg-white w-full md:w-1/3 h-1/4 px-5 pt-4 relative rounded-2xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-3 right-3 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />
        <p className="font-bold text-sm text-textBlue1 border-b p-4 pb-1">Bulk Upload</p>
        {showLoader && (
          <img
            src="assets/img/loader.svg"
            className="w-18 mx-auto absolute left-2/4 top-1/4 z-50"
            style={{ left: '40%' }}
            alt=""
          />
        )}
        {save ? null : (
          <div
            className="inputLabelText px-4 mt-6 py-4 focus:outline-none relative text-sm"
            style={{ width: '92%', left: '4%', color: '#9B9B9B' }}
            onClick={onClick}
          >
            <img src="assets/img/upload2.svg" className="w-5 mr-3 absolute right-0" alt="" />
            <input ref={uploadFile} accept=".csv" className="hidden" onChange={handleFiles} type="file" id="input" />
            Choose the file
          </div>
        )}

        {fileName ? (
          <div className="uppercase focus:outline-none  text-parameter  border border-secondary font-medium text-base flex justify-center items-center mt-4 py-3 w-48">
            <div>{fileName}</div>
            <img
              src="assets/img/Close.svg"
              className="w-3 ml-3 mb-2"
              alt=""
              onClick={() => {
                setDevices([]);
                setSave(!save);
                setFileName('');
              }}
            />
          </div>
        ) : null}

        {save ? (
          <button
            type="submit"
            className="uppercase focus:outline-none  text-parameter  border border-secondary font-medium text-base flex justify-center 
            items-center mt-8 ml-4 py-3 w-48 absolute left-2/4 bg-btnBg"
            style={{ top: '25%', color: 'white' }}
            onClick={uploadDevice}
          >
            <img src="assets/img/Upload.svg" className="w-6 mr-3" alt="" />
            SAVE CSV
          </button>
        ) : null}
        {/* (
        <button
          type="submit"
          className="uppercase focus:outline-none text-parameter border border-secondary font-medium text-base flex justify-center items-center ml-14 py-4 w-48"
          onClick={uploadDevice}
        >
          <img src="assets/img/Upload.svg" className="w-7 mr-3 " alt="" />
          SAVE CSV
        </button>
      )  */}
        {/* 
   <button
    type="submit"
    onClick={uploadDevice}
    style={{
     position: 'absolute',
     right: '-50px',
     marginTop: '1.6em',
     padding: '0.5em 1em',
     fontSize: '1.2em',
     color: 'blue',
     fontWeight: '700',
    }}
   >
    SAVE
   </button> */}
        {/* <button className="uppercase focus:outline-none text-parameter font-medium text-base flex justify-center items-center ml-14 py-4 w-48">
    <img src="assets/img/Close.svg" className="w-7 mr-3 " alt="" />
    
   </button> */}
      </div>
    </div>
  );
}

export default index;
